/**
 * Design + domain constants for EPScatter. Kept in one place so the
 * components only deal with semantics.
 */

export const PROVINCES = {
	'04': 'Almería',
	11: 'Cádiz',
	14: 'Córdoba',
	18: 'Granada',
	21: 'Huelva',
	23: 'Jaén',
	29: 'Málaga',
	41: 'Sevilla'
};

/**
 * Mirrors the map's color_styles.css (--1 … --11). Key is the second
 * element of raw.partidos[year-idx] (the "code"), so map and scatter
 * use the same hue for the same party.
 */
export const COLOR_BY_CODE = {
	1: '#ED1C24',
	2: '#0055A7',
	3: '#DB0626',
	4: '#1CA439',
	5: '#5AC035',
	6: '#FE5000',
	7: '#019843',
	8: '#068F54',
	9: '#24C87F',
	10: '#6A2E68',
	11: '#9169F4'
};

/** Long names used in tooltips and legend (title attribute). */
export const PARTIES_DEFAULT = {
	PSOE: { long: 'Partido Socialista Obrero Español' },
	'PSOE-A': { long: 'Partido Socialista de Andalucía' },
	PP: { long: 'Partido Popular' },
	'PP-A': { long: 'Partido Popular de Andalucía' },
	AP: { long: 'Alianza Popular' },
	'AP-PDP-UL': { long: 'AP-PDP-UL (coalición)' },
	UCD: { long: 'Unión de Centro Democrático' },
	PA: { long: 'Partido Andalucista' },
	'PSA-PA': { long: 'Partido Socialista de Andalucía – Partido Andalucista' },
	PSA: { long: 'Partido Socialista de Andalucía' },
	IU: { long: 'Izquierda Unida' },
	'IULV-CA': { long: 'IU Los Verdes – Convocatoria por Andalucía' },
	'IU-CA': { long: 'Izquierda Unida – Convocatoria por Andalucía' },
	PCE: { long: 'Partido Comunista de España' },
	PCA: { long: 'Partido Comunista de Andalucía' },
	CDS: { long: 'Centro Democrático y Social' },
	Cs: { long: 'Ciudadanos' },
	VOX: { long: 'Vox' },
	Vox: { long: 'Vox' },
	UPyD: { long: 'Unión Progreso y Democracia' },
	PODEMOS: { long: 'Podemos' },
	Pod: { long: 'Podemos' },
	UP: { long: 'Unidas Podemos' },
	AA: { long: 'Adelante Andalucía' },
	xA: { long: 'Por Andalucía' }
};

export const PARTY_DEFAULT_COLOR = '#888';

/** Legacy alias retained for one release — prefer AUTOPLAY_STEP_MS. */
export const PLAY_INTERVAL_MS = 1400;

/** Time between auto-advances of the year while autoplay is active. */
export const AUTOPLAY_STEP_MS = 1200;

/** Pause held at the last year before looping back to the first. */
export const END_YEAR_PAUSE_MS = 1500;

/** IntersectionObserver tuning for the visibility-driven autoplay. */
export const INTERSECTION_ROOT_MARGIN = '300px 0px 300px 0px';
export const INTERSECTION_THRESHOLD = 0.15;

/** Sqrt-scaled radius range (px). Caps Sevilla/Málaga so they don't dominate. */
export const RADIUS_RANGE = [3, 16];

/** Single source of truth for the mobile breakpoint (mirrors the map). */
export const MOBILE_BREAKPOINT = 599;

/** Margin in px around the plot area (inside the SVG). */
export const PLOT_MARGIN_DESKTOP = { top: 28, right: 22, bottom: 48, left: 38 };
export const PLOT_MARGIN_MOBILE = { top: 24, right: 12, bottom: 44, left: 32 };
